const ReviewsComponent = {
    data() {
        return {
            items: [],
            loading: false,
            showAllLink: false,

            expandedId: null,
        };
    },

    methods: {
        async getReviews() {
            this.loading = true;

            try {
                const limit = 3;

                const params = {
                    limit,
                    onlyVisible: true
                };

                /**
                 * Автоопределение врача из URL
                 */
                const specialistId = this.detectSpecialistIdFromUrl();

                if (specialistId) {
                    params.userId = specialistId;
                }

                const response = await window.reviewService.getReviews(params);
                const raw = response?.data ?? [];

                this.items = raw.map((row) =>
                    this.normalizeItem(row)
                );

                /**
                 * Показываем ссылку "Все отзывы"
                 * только если это НЕ страница врача
                 */
                this.showAllLink = !specialistId;

                if (this.items.length) {
                    this.$nextTick(() => {
                        this.initStars();
                        this.checkLongTexts();
                    });
                }

            } catch (e) {
                console.error('[REVIEWS] getReviews failed', e);
                this.items = [];
                this.showAllLink = false;
            } finally {
                this.loading = false;
            }
        },

        detectSpecialistIdFromUrl() {
            const path = window.location.pathname;

            /**
             * Ищем формат:
             * /specialists/6
             */
            const match = path.match(/^\/specialists\/(\d+)(\/)?$/);

            if (!match) {
                return null;
            }

            return Number(match[1]);
        },

        normalizeItem(row) {
            const name = (row?.client || '').trim() || 'Клиент';
            const initials = (row?.initials || '').trim() || this.buildInitials(name);
            const source = row?.source ? `Источник: ${row.source}` : 'Отзыв';

            const text = this.stripHtml(row?.reviewText || '');
            return {
                id: row?.id ?? null,
                initials,
                name,
                source,
                rating: Number(row?.rating ?? 0) || 0,
                text,
                isLong: false,
            };
        },

        checkLongTexts() {
            const els = this.$el.querySelectorAll('.text-container');

            els.forEach((el, index) => {
                if (this.items[index]) {
                    this.items[index].isLong =
                        el.scrollHeight > el.clientHeight;
                }
            });
        },

        toggle(item) {
            const id = item?.id ?? null;

            if (this.expandedId === id) {
                this.expandedId = null;
                return;
            }

            this.expandedId = id;
        },

        isExpanded(item) {
            const id = item?.id ?? null;
            return id !== null && this.expandedId === id;
        },

        buildInitials(name) {
            const parts = (name || '')
                .split(' ')
                .map(s => s.trim())
                .filter(Boolean);

            const a = (parts[0]?.[0] || '').toUpperCase();
            const b = (parts[1]?.[0] || '').toUpperCase();

            return (a + b) || '—';
        },

        stripHtml(html) {
            const div = document.createElement('div');
            div.innerHTML = html || '';
            return (div.textContent || div.innerText || '').trim();
        },

        initStars() {
            if (typeof window.$ === 'undefined' || typeof window.$.fn?.rateYo === 'undefined') {
                return;
            }

            const root = this.$el;
            const els = root.querySelectorAll('.reviews-stars');

            els.forEach((el) => {
                const rating = Number(el.getAttribute('data-rateyo-rating') || 0);

                if (el.__rateYoInited) return;
                el.__rateYoInited = true;

                window.$(el).rateYo({
                    rating,
                    readOnly: true,
                    starWidth: "22px",
                    spacing: "4px",
                    ratedFill: "#ffb400",
                    normalFill: "#dfe1e4",
                });
            });
        },
    },

    mounted() {
        this.getReviews();
    },
};

window.ReviewsComponent = ReviewsComponent;